// extracted by mini-css-extract-plugin
export default {"qrcodeBox":"EmailForm_qrcodeBox__Etfsk","qrcodeImg":"EmailForm_qrcodeImg__Zd6Vy","expiredBox":"EmailForm_expiredBox__qIanE"};